// Reference for anchors:
// https://github.com/asyncapi/asyncapi-react/blob/master/docs/features/anchors.md
// eslint-disable-next-line import/prefer-default-export
export function generateAsyncApiLinks(spec) {
  if (!spec || typeof spec === 'string' || Object.keys(spec) === 0) {
    return [];
  }

  const servers = {
    name: 'Servers',
    href: 'servers',
    children: Object.entries(spec.servers || {}).map(([k]) => {
      return {
        name: k,
        href: `server-${k}`,
      };
    }),
  };

  const operations = {
    name: 'Operations',
    href: 'operations',
    children: Object.entries(spec.operations || {}).map(([k, v]) => {
      return {
        name: k,
        href: `operation-${v.action}-${k}`,
      };
    }),
  };

  const messages = {
    name: 'Messages',
    href: 'messages',
    children: Object.entries(spec.components?.messages || {}).map(([k]) => {
      return {
        name: k,
        href: `message-${k}`,
      };
    }),
  };

  const schemas = {
    name: 'Schemas',
    href: 'schemas',
    children: Object.entries(spec.components?.schemas || {}).map(([k]) => {
      return {
        name: k,
        href: `schema-${k}`,
      };
    }),
  };

  return [servers, operations, messages, schemas];
}
